enum PayAnyoneStatus {
  cancelled = 'cancelled',
  reversed = 'reversed',
  expired = 'expired',
  pending = 'pending',
  sent = 'sent',
  succeeded = 'succeeded',
  failed = 'failed',
  step_up_required = 'step_up_required',
}

export default PayAnyoneStatus;
